module.exports = __webpack_public_path__ + "fa-brands-400.099a9556e1a63ece24f8.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-brands-400.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.woff
// module chunks = styles